function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7383BF"
    },
    d: "M7.828,255h494.345C502.172,118.172,391.828,7.828,255,7.828S7.828,118.172,7.828,255 S118.172,502.172,255,502.172V7.828"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434C6D"
    },
    d: "M255,511C113.759,511-1,396.241-1,255S113.759-1,255-1s256,114.759,256,256 c0,5.297-3.531,8.828-8.828,8.828H263.828v238.345C263.828,507.469,260.297,511,255,511z M16.655,263.828 c4.414,124.469,105.048,225.103,229.517,229.517V263.828H16.655z M263.828,246.172h229.517 C488.931,121.703,388.297,21.069,263.828,16.655V246.172z M16.655,246.172h229.517V16.655 C121.703,21.069,21.069,121.703,16.655,246.172z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434C6D"
    },
    d: "M255,511c-0.883,0-2.648,0-3.531,0h-5.297l-2.648-1.766 C166.724,446.559,122.586,353.869,122.586,255S166.724,63.441,243.524,0.766L246.172-1h5.297c0.883,0,2.648,0,3.531,0 c5.297,0,8.828,3.531,8.828,8.828s-3.531,8.828-8.828,8.828c-0.883,0-1.766,0-2.648,0C180.848,75.8,140.241,162.31,140.241,255 s40.607,179.2,112.11,238.345c0.883,0,1.766,0,2.648,0c5.297,0,8.828,3.531,8.828,8.828S260.297,511,255,511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434C6D"
    },
    d: "M255,149.069c-66.207,0-129.766-19.421-184.497-56.497c-3.531-3.531-4.414-8.828-1.766-12.359 c2.648-4.414,7.945-5.297,12.359-2.648c51.2,35.31,112.11,53.848,173.903,53.848s122.703-18.538,173.903-53.848 c4.414-2.648,9.71-1.766,12.359,2.648c2.648,4.414,1.766,9.71-2.648,12.359C384.766,129.648,321.207,149.069,255,149.069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434C6D"
    },
    d: "M70.503,428.903c-2.648,0-5.297-0.883-7.062-3.531c-2.648-3.531-1.766-9.71,1.766-12.359 c56.497-39.724,121.821-60.91,189.793-60.91c5.297,0,8.828,3.531,8.828,8.828s-3.531,8.828-8.828,8.828 c-64.441,0-126.234,19.421-179.2,57.379C74.034,428.021,72.269,428.903,70.503,428.903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434C6D"
    },
    d: "M378.586,263.828c-5.297,0-8.828-3.531-8.828-8.828c0-92.69-40.607-179.2-112.11-238.345 c-0.883,0-1.766,0-2.648,0c-5.297,0-8.828-3.531-8.828-8.828S249.703-1,255-1c0.883,0,2.648,0,3.531,0h5.297l2.648,1.766 C343.276,63.441,387.414,156.131,387.414,255C387.414,260.297,383.883,263.828,378.586,263.828z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7D3BA"
    },
    d: "M315.028,427.138L315.028,427.138l-17.655,64.441l40.607-40.607L315.028,427.138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D75A4A"
    },
    d: "M485.4,303.552l-10.593-10.593c-7.062-7.062-17.655-7.062-24.717,0l-31.779,31.779l23.835,23.834 L485.4,303.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED8A19"
    },
    d: "M441.262,347.69l-23.835-23.835l-102.4,103.283l23.834,23.834L441.262,347.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CBB7A1"
    },
    d: "M365.345,477.455L365.345,477.455l-26.483-26.483l-40.607,40.607l-0.883,4.414L365.345,477.455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8F3431"
    },
    d: "M467.745,374.172l31.779-31.779c7.062-7.062,7.062-17.655,0-24.717L485.4,303.552l-44.138,44.138 L467.745,374.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7791D"
    },
    d: "M338.862,450.09l26.483,26.483l102.4-102.4l-26.483-26.483L338.862,450.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C4C4C"
    },
    d: "M290.31,511c-2.648,0-4.414-0.883-6.179-2.648c-3.531-3.531-3.531-8.828,0-12.359l19.421-19.421 c3.531-3.531,8.828-3.531,12.359,0c3.531,3.531,3.531,8.828,0,12.359l-19.421,19.421C294.724,510.117,292.959,511,290.31,511"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.88d0876ed5094091891d2bb902295aa4.svg";
export { ForwardRef as ReactComponent };